import { useEffect, useState } from "react";

/* live phone-breakpoint flag — used to keep hidden-on-phone artwork out
   of the render tree entirely, so its lazy chunks are never fetched */
export function useIsPhone() {
  const [phone, setPhone] = useState(
    () => window.matchMedia("(max-width: 768px)").matches
  );
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const update = () => setPhone(mq.matches);
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);
  return phone;
}
